import React from 'react';
import _ from 'lodash';
import showTable from './showTable';
import { TabItemPill } from '../../../components/Pill';
import { PedidoItemAction } from '../../../components/MenuItem';

const Tabla = (props) => {


  if (props.pedidos.length === 0) return null;

  const pedidos = _.filter(props.pedidos, _.property(props.numProfVeh))[0][props.numProfVeh];
  return (
    <div className='tab-content' id='proformasTablas'>
      <div className='tab-pane active' id='fechas'>
        <div className='hidden-xs'>
          <div className='tableWrapper' style={{overflow:'inherit'}}>
            { showTable(props, pedidos) }
          </div>
        </div>
      </div>
    </div>
  );
};

const Pedidos = props => (
  <div className='fdv-pedidos' id='pedidosTableInfo'>
    <div className='fdv-pedidos-actions'>
      <div className='fdv-pedidos-btns'>
        <button className='btn btn-blue btn-sm' onClick={(e) => props.handlePermissionsMassive(e,props.pedidosConCheck) && props.openModal('ValidarAsignacion')}  data-permisos='ind_asigna_defi'>Validar asignación</button>
        <div className={`btnDrop dropdown customToggle ${props.pedidosConCheck.length > 0 ? '' : 'js-hide'}`} >
          <button className='btn dropdown-toggle btn-sm btn-blue' value={props.numProfVeh} onClick={props.handleClick}><span>Más</span><i className='ion-arrow-down-b ml-2' /></button>
          <ul className='dropdown-menu'>
            <PedidoItemAction action={props.openModal} actionParam='AplicarColorUso' iconClass='ion-paintbucket' name='Aplicar color y uso' permiso='ind_aplicar_uso_color' handlePermissionsMassive={props.handlePermissionsMassive} pedidos={props.pedidosConCheck} />
            <PedidoItemAction action={props.openModal} numProfVeh={props.numProfVeh} actionParam='SolicitarFacturacion' iconClass='ion-document-text' name='Solicitar facturación' permiso='ind_nueva_sol_fact' handlePermissionsMassive={props.handlePermissionsMassive} pedidos={props.pedidosConCheck} />
            <PedidoItemAction action={props.openModal} numProfVeh={props.numProfVeh} actionParam='EditaDatosSolicitarFacturacion' iconClass='ion-document-text' name='Editar datos de facturación' permiso='ind_editar_datos_fact' handlePermissionsMassive={props.handlePermissionsMassive} pedidos={props.pedidosConCheck} />
            <PedidoItemAction action={props.openModal} actionParam='AgregarEquiposAdicionales' iconClass='ion-plus-circled' name='Agregar equipos' permiso='ind_agregar_equipo' handlePermissionsMassive={props.handlePermissionsMassive} pedidos={props.pedidosConCheck} />
            <PedidoItemAction action={props.openModal} actionParam='AgregarBonos' iconClass='ion-cash' name='Generar bono' permiso='ind_agregar_bono' handlePermissionsMassive={props.handlePermissionsMassive} pedidos={props.pedidosConCheck} />
            {/*<PedidoItemAction action={props.openEdit} actionParam={7} iconClass='ion-edit' name='Editar fechas compromiso' permiso='ind_editar_fec_compromiso' handlePermissionsMassive={props.handlePermissionsMassive} pedidos={props.pedidosConCheck} />*/}
            <PedidoItemAction action={props.openModal} actionParam='DesasignarPedido' iconClass='ion-trash-a' name='Desasignar' permiso='ind_desasignar' handlePermissionsMassive={props.handlePermissionsMassive} pedidos={props.pedidosConCheck} />
            {/* <I 86111> ivelasquez 12/03/2021 */}
            <PedidoItemAction action={props.openModal} actionParam='CorreoPedidos' iconClass='ion-calendar c-cyan' name='Envío de Facturación' permiso='ind_nueva_sol_fact' handlePermissionsMassive={props.handlePermissionsMassive} pedidos={props.pedidosConCheck} />
            {/* <F 86111> ivelasquez 12/03/2021 */}
          </ul>
        </div>
      </div>
      <ul className='tabs' role='tablist'>
      <TabItemPill index={1} active={props.activeFilterPedido} iconPill='ion-model-s' name='Tracking' changeIndex={props.changeIndex} />
        <TabItemPill index={0} active={props.activeFilterPedido} iconPill='ion-calendar' name='F. compromiso' changeIndex={props.changeIndex} />
        <TabItemPill index={3} active={props.activeFilterPedido} iconPill='ion-document-text' name='Facturacion' changeIndex={props.changeIndex} />
        {/* <TabItemPill index={4} active={props.activeFilterPedido} iconPill='ion-cash' name='Pagos' changeIndex={props.changeIndex} /> */}
        <TabItemPill index={5} active={props.activeFilterPedido} iconPill='ion-paintbucket' name='Uso y color' changeIndex={props.changeIndex} />
        {/*<TabItemPill index={6} active={props.activeFilterPedido} iconPill='ion-ios-people' name='Validaciones' changeIndex={props.changeIndex} />*/}
          <TabItemPill index={2} active={props.activeFilterPedido} iconPill='ion-checkmark-circled' name='Etapas' changeIndex={props.changeIndex} />
      </ul>
    </div>
    <Tabla
      pedidos={props.pedidos}
      numProfVeh={props.numProfVeh}
      activeFilterPedido={props.activeFilterPedido}
      selectCheckPedidos={props.selectCheckPedidos}
      pedidosConCheck={props.pedidosConCheck}
      selectAll={props.selectAll}
      loading={props.loading}
      openAlert={props.openAlert}
      changeIndex={props.changeIndex}
      fdvID = {props.fdvID}
      isFinishedAsignacionDefinitiva={props.isFinishedAsignacionDefinitiva}
      doneAsignacionDefinitiva={props.doneAsignacionDefinitiva}
      listaCorreos={props.listaCorreos}//Req 92528 ebarboza 30 08 2021
    />
  </div>
);

export default Pedidos;



// WEBPACK FOOTER //
// ./src/pages/DetalleFichaVenta/DetallePedido/index.js